import btnClose from "../../assets/images/svg/close_modal_icon.svg";
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Modal } from "react-bootstrap";
import ModalLoader from "./modalLoader";
import { InfoToast } from "../../shared";

const ModalLogMoadian = ({
    item,
    showLog,
    loading,
    modalContent,
    handleClose,
    modalHeader,   
    infoClick

}) => {
   

    return (
        <>
             <Modal show={showLog} onHide={handleClose} animation={true} dir="rtl" className={`invoice-modal ${infoClick?'log-view"':''}`} >
                <Modal.Header>
                    <Modal.Title className="d-flex justify-content-between w-100" style={{ fontSize: '16px' }}>
                        <div className="d-flex justify-content-between w-100">
                            <span>{modalHeader}</span>
                            <div className="close-section">
                                <img
                                    onClick={handleClose}
                                    alt={'info'}
                                    src={btnClose}
                                />
                            </div>

                        </div>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className='invoice-modal-content-view'>
                    {item?.StatusEn !== 'ReturnRevoke' && loading ? <ModalLoader /> :
                        infoClick ? item?.MoadianLog: Object.keys(modalContent).map((key, index) => {
                            if (modalContent[key] !== null && modalContent[key] !== '') {
                                return (<div key={index} className='json-item'>
                                    <b>{modalContent[key]}</b>:   <label>{key} </label>
                                </div>)
                            } else {
                                return null
                            }
                        }) 
                           }
                    {item?.StatusEn === 'ReturnRevoke' && !loading &&
                        <div className="modal-details">
                            <div>
                                <span> مشترک :</span>
                                <span>{
                                    item?.FactorIssueType === 2 ?
                                        item?.CompanyName ? item?.CompanyName : '---' :
                                        item?.FirstNameAndLastName ? item?.FirstNameAndLastName : '---'}
                                </span>
                            </div>
                            <div>
                                <span> ایمیل :</span>
                                <span>{item?.EmailRevokOrReturned ? item?.EmailRevokOrReturned : '---'}</span>
                            </div>
                            <div>
                                <span> مبلغ :</span>
                                {<span>{item?.TotalAmountReservedOrReturned ? item?.TotalAmountReservedOrReturned : '---'}</span>}
                            </div>
                            <div>
                                <span> درگاه :</span>
                                {<span>{item?.GatewayName}</span>}
                            </div>
                            <div>
                                <span> تاریخ تراکنش :</span>
                                {<span>{item?.Revoked ?
                                    item?.PersianIssueDate ? item?.PersianIssueDate : '---' :
                                    item?.ParentPersianIssueDate ? item?.ParentPersianIssueDate : '---'

                                }</span>}
                            </div>
                            <div className="d-flex justify-content-start">
                                <span>شماره مودیان :</span>
                                <span>{item?.ParentTaxId ? item?.ParentTaxId : '---'}</span>
                            </div>
                            <div>
                                <span>شماره فاکتور :</span>
                                <span>{
                                    item?.Revoked ?
                                        item?.InvoiceNumberInFactorFa ? item?.InvoiceNumberInFactorFa : '----' :
                                        item?.ParentInvoiceNumberInFactor ? item?.ParentInvoiceNumberInFactor : '----'}</span>
                            </div>
                        </div>

                    }
                </Modal.Body>

                {!infoClick && !loading && item?.StatusEn !== 'ReturnRevoke' && <Modal.Footer className="d-flex flex-row justify-content-center">
                    <CopyToClipboard text={JSON.stringify(modalContent)} onCopy={() => InfoToast("کد مورد نظر با موفقیت کپی شد")}>
                        <button
                            color="primary"
                            type="button"
                            className="button-invoice-approve"
                        >
                            کپی کردن
                        </button>
                    </CopyToClipboard>
                </Modal.Footer>}
            </Modal>
        </>
    )
}

export default ModalLogMoadian